export const api_notifications = {
  getNotificationById: (userId, id) => ({api: `/api/v2/medCenters/${userId}/notifications/${id}`, method: "GET"}),
  changeStatus: (userId, id) => ({api: `/api/v2/medCenters/${userId}/notifications/${id}/status`, method: "PUT"}),
}